// extracted by mini-css-extract-plugin
export default {"alert":"_2ETtDGCZmp4PmyXpUMDXuE","bold":"Gm8MrqoGIXfhj3w1nnt1x","underline":"_1PL5CylMs24nyUTYGC8lPZ","link":"_1vbuSoAFoMcFah-EqM6TVu","close_button":"_37eOJYZSOhRzoH_h3Z4RFT"};